import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubbleWide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBubbleWide"><Path fillRule="evenodd" clipRule="evenodd" d="M22.002 19.0357V3L2.00195 3.00003V19.0358H8.65157L11.9939 21.8375L15.3757 19.0358L22.002 19.0357Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBubbleWide;
